<template>
  <div class="protocol-container">
    <div class="logo-wrap">
      <router-link :to="{ name: 'Home' }">
        <img class="header-img" :src="brandLogo" alt="" />
      </router-link>
    </div>
    <div class="agreement-content">
      <h1>魔果云课用户服务协议</h1>
      <p>更新日期：2024年06月10日</p>
      <p>
        欢迎您使用北京闵氏超体网络科技有限公司
        (以下简称“我们”或者“魔果”)所提供的魔果云课服务（以下简称 “本服务”、
        “魔果云课”或“平台”），魔果云课
        是一个为独立的知识传授者、分享者提供完善的在线教育工具和平台能力，为求知者提供丰富的知识内容和一起学习的社群环境的实时互动教育平台。
      </p>
      <p>
        【请审慎阅读】为获得魔果云课提供的服务（以下称为“本服务”）,
        您在使用前应当认真阅读、充分理解本《协议》中各条款,特别是免除或者限制魔果责任的免责条款、对用户的权利进行限制的条款、约定争议解决方式和司法管辖的条款以及开通或使用某项服务的单独协议或规则。请审慎阅读并选择接受或不接受本《协议》(如果申请人因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人的陪同下阅读并判断是否同意本协议)。
      </p>
      <p>
        申请人同意接受本协议的全部条款的,应当按照页面上的提示完成全部的注册程序,
        并在注册程序过程中点选“同意”
        视为您已阅读并同意签署本协议。本协议即在您与魔果之间产生法律效力，成为对双方均具有约束力的法律文件；申请人不同意接受本协议的全部条款或部分条款的，申请人应当立即退出注册申请或终止使用本服务。
      </p>
      <p>
        本《协议》可由魔果定期更新
        您可在魔果查阅最新版协议条款。如果您不接受修改后的条款,
        请立即停止使用魔果提供的本服务,
        继续使用的用户将被视为已接受了修改后的协议。
      </p>
      <h2>1.术语含义</h2>
      <p>如无特别说明，下列术语在本协议中的含义为：</p>
      <p>
        1.1
        用户：指经有效注册、申请帐号后，通过魔果云课，可以享受各种免费或收费类的互动教学、点播形式的交流与学习服务的个人、法人或其他组织。本协议中简称为“您”或“用户”。
      </p>
      <p>
        1.2
        知识分享者：指经有效注册、申请后，将其享有相应权利的各种知识接入魔果云课并向用户提供各种免费或收费类的在线互动教学、点播服务以实现与用户进行在线交流与学习目的的个人、法人或其他组织，因前述主体的不同，知识分享者对外也称“机构”或“知识分享者”，其中知识分享者指个人，机构指法人或其他组织；本协议中简称为“您”或“分享者”。
      </p>
      <p>注：如没有明确前缀界定“您”的释义，则“您”的释义包含用户和分享者。</p>
      <p>
        1.3
        知识内容：指由分享者开发，或分享者经权利人授权，通过魔果云课向相关用户提供各种免费或收费类的互动教学、点播形式的交流与学习服务，包括但不限于会计类、网络营销类、公务员考试类、语言类等现有的各种培训服务及今后可能出现的各种培训服务。
      </p>
      <p>
        1.4魔果：指北京闵氏超体网络科技有限公司，或其控制、运营的魔果云课服务平台（www.comettech.com）。
      </p>
      <p>
        魔果云课：指由魔果所控制、运营的魔果云课软件平台（包括comettech.com及魔果云课软件），以下简称为“魔果云课”、“平台”。
      </p>
      <h2>魔果与您均同意和理解：</h2>
      <div class="list-wrap">
        <p>
          （1）魔果云课是一个中立的平台服务提供方，仅向分享者提供信息存储空间、在线传播等中立的网络服务或相关中立的技术支持服务，以供分享者在中立的平台上自主发布、推广其知识内容等；
        </p>
        <p>（2）分享者的知识内容由分享者自主开发、发布并独立承担全部责任；</p>
        <p>
          （3）因分享者分享内容及服务产生的任何纠纷、责任等，以及分享者违反相关法律法规或本协议约定引发的任何后果，均由分享者独立承担责任、赔偿损失，与魔果云课无关。如侵害到魔果云课、魔果及其关联公司或他人权益的，分享者须自行承担全部责任和赔偿一切损失。对于第三方因分享者分享的内容向魔果云课主张权利的，魔果云课在核实情况后告知分享者需下架相关分享内容，若分享者未在魔果云课的规定期限内下架，魔果有权直接采取删除、屏蔽等必要措施，以及停止侵权内容的结算。
        </p>
      </div>
      <h2>账号注册</h2>
      <p>
        2.1
        您应当通过登录魔果云课网站、软件或魔果指定的其他途径，注册用户账号及分享者账号（下简称：魔果云课账号）以成为用户或分享者，魔果云课账号一经注册成功，该账号不可转让、不可赠与、不可继承等。
      </p>
      <p>
        2.2
        您不得违反本协议约定将您的魔果云课账号用于其他目的。否则，魔果有权随时单方限制、中止或终止向您提供本服务，且未经魔果同意您不得再次使用本服务。
      </p>
      <p>
        2.3
        您注册的魔果云课账号，是您登录及使用本服务的凭证。您应当做好魔果云课账号、密码，以及进入和管理本服务中的各类产品与服务的口令、密码等的保密措施。因您保密措施不当或您的其他行为，致使上述口令、密码等丢失或泄漏所引起的一切损失和后果，均由您自行承担。
      </p>
      <p>
        2.4
        魔果云课可能会向分享者提供添加其他魔果云课账号，以成为分享者注册账号的账号管理员的功能，如魔果向分享者提供账号管理员功能后，分享者可以根据自己的需求，在使用相应魔果云课账号注册成分享者所认证账号的机构（账号）管理员或机构工作者后，进行分享者指定或授权的操作。
      </p>
      <p>
        2.5
        您保证不得通过任何手段恶意注册魔果云课账号，包括但不限于以牟利、炒作、套现、获奖等为目的多个账号注册，亦不得盗用其他用户账号。如您违反上述规定，则魔果有权直接采取一切必要的措施，包括但不限于删除您发布的内容、暂停或查封用户账号，取消因违规所获利益，以及通过诉讼形式追究您法律责任等。
      </p>
      <p>
        2.6
        若您发现有他人冒用或盗用您的账号及密码、或任何其他未经您合法授权的情形时，
        您应立即以有效方式通知魔果并提供魔果所需的相关材料（包括但不限于提供您的身份信息和相关身份资料、相关事实情况及您的要求等）。魔果收到您的有效请求并核实身份后，会根据不同情况采取相应措施。若您提供的信息不完全，导致魔果无法核实您的身份或魔果无法判断您的需求等，
        而导致魔果无法进行及时处理，给您带来的损失，您应自行承担。同时，魔果对您的请求采取措施需要合理期限，对于您通知魔果以及魔果根据您的有效通知采取措施之前，由于他人行为给您造成的损失，魔果不承担任何责任。
      </p>
      <h2>服务费用及结算方式</h2>
      <p>
        3.1魔果仅提供相关的网络服务，除此之外的与相关网络服务有关的设备（如电脑、调制解调器、以及其他与接入互联网有关的装置）及所需的费用（如为接入互联网而支付的电话费以及上网费）均由您自行负担。
      </p>
      <p>
        3.2若分享者在魔果云课平台进行分享服务所获得的收益，魔果有权自行或委托第三方，包括但不限于银行、第三方支付公司等，按照《魔果云课结算说明》与分享者进行结算。为委托第三方支付结算事宜，分享者同意授权魔果向第三方提供开具结算账户并进行代收付所必要的个人/企业信息（包括但不限于身份信息、营业执照、信用信息、联系信息等）。
      </p>
      <p>
        分享者应认真阅读上述《结算说明》，并确认收益、服务费用的结算流程以上述文档的最新版本为准。魔果《魔果云课结算说明》将作为本协议附件（详见附件），是本协议不可分割的一部分。
      </p>
      <p>
        分享者同意：在满足魔果《魔果云课结算说明》约定的付款条件后，魔果将与分享者进行结算，分享者在魔果云课取得的服务收益自行承担税费，魔果不承担相关税费义务。
      </p>
      <p>
        3.3目前，魔果向分享者提供的魔果云课基本服务是免费的，如后续魔果可能会对服务进行调整，并有权根据运营情况单独决定是否向分享者收取相应服务费用。
      </p>
      <p>
        在本服务中，魔果如需对服务收取相应服务费用的，魔果有权单方根据实际需要对收费服务的收费标准、方式进行修改和变更，前述修改、变更前，魔果将在相应服务页面进行通知或公告。如果分享者会予以全部遵守、同意，则可以继续使用魔果云课服务。如果分享者不同意上述修改、变更，则应立即停止使用相应服务，否则，分享者的任何使用行为，即视为分享者同意上述修改、变更。
      </p>
      <h2>分享规则</h2>
      <p>
        4.1分享者在使用魔果云课服务过程中, 必须遵循国家的相关法律法规,
        不得发布危害国家安全、色情、暴力、侵犯版权等任何合法权利等非法内容;
        也不得利用平台发布含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、或其它道德上令人反感的内容。
      </p>
      <p>
        4.2魔果可依其合理判断, 对违反有关法律法规或本协议约定;
        或侵犯、妨害、威胁任何人权利或安全的内容, 或者假冒他人的行为,
        魔果有权停止传输任何前述内容,
        并有权依其自行判断对违反本条款的任何用户采取适当的法律行动,
        包括但不限于, 删除具有违法性、侵权性、不当性等内容,
        阻止其使用魔果全部或部分网络服务,
        并且依据法律法规保存有关信息并向有关部门报告等。
      </p>
      <p>
        4.3对于经由魔果网络服务而传送的内容,
        魔果不保证前述内容的正确性、完整性或品质。您在接受本服务时,
        有可能会接触到令人不快、不适当或令人厌恶的内容。在任何情况下,
        魔果均不对任何内容负责,
        包括但不限于任何内容发生任何错误或纰漏以及衍生的任何损失或损害。魔果有权(但无义务)自行拒绝或删除经由魔果网络服务提供的任何内容。您使用上述内容,
        应自行承担风险。
      </p>
      <p>
        4.4
        魔果对分享者发布带有商业广告特征的文字、图片等宣传推广信息仅承担《中华人民共和国广告法》所指互联网信息服务提供者责任。分享者应对前述内容真实性负责并承担《中华人民共和国广告法》所指广告主及或广告发布者责任。用户搜索、浏览、接受上述宣传推广信息，应审慎辨别，自行承担广告风险。
      </p>
      <p>
        4.5对于分享者通过魔果网络服务上传到魔果上可公开获取区域的任何内容,
        分享者同意魔果在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可,
        以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容(整体或部分),
        和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。
      </p>
      <p>
        4.6您通过魔果网络服务所发布的任何内容并不反映魔果的观点或政策,
        魔果对此不承担任何责任。您须对上述内容的真实性、合法性、无害性、有效性等全权负责,
        与您所发布信息相关的任何法律责任由您自行承担, 与魔果无关。
      </p>
      <h2>关于用户数据的规则</h2>
      <p>
        5.1
        您不得收集用户的隐私信息数据及其他魔果及其关联公司认为属于敏感信息范畴的数据，包括但不限于不得收集或要求用户提供任何魔果云课账号、密码、用户关系链、好友列表数据、银行账号和密码等。
      </p>
      <p>5.2您不得使用魔果云课数据用于向用户进行广告宣传使用。</p>
      <p>
        5.3魔果有权限制或阻止您获取用户数据及魔果云课数据。如果魔果及其关联公司认为您收集、使用用户数据的方式，可能损害用户体验，魔果有权要求您删除相关数据并不得再以该方式收集、使用用户数据。
      </p>
      <p>
        5.4未经魔果事先书面同意，
        您不得为本协议约定之外的目的使用用户数据或平台运营数据，亦不得以任何形式将前述数据提供给他人。
      </p>
      <p>
        5.5一旦您停止使用魔果云课，或魔果基于任何原因终止您使用本服务，您必须立即删除全部从魔果云课中获得的数据（包括各种备份），且不得再以任何方式进行使用。
      </p>
      <p>
        5.6您应自行对因使用本服务而存储在魔果及其关联公司服务器的各类数据等信息，在本服务之外，采取合理、安全的技术措施，确保其安全性，并对自己的行为（包括但不限于自行安装软件、采取加密措施或进行其他安全措施等）所引起的结果承担全部责任。
      </p>
      <h2>关于法律责任</h2>
      <p>
        6.1
        您同意并理解，分享者是分享内容的合法权利人，私自录像或未经合法权利人同意擅自传播属于侵权行为；发生诉讼纠纷的，分享者应当与侵权者协商、诉讼解决，侵权者应该依法承担相应的责任；魔果云课有权协助分享者制止侵权者的侵权行为，包括但不限于封号处理。
      </p>
      <p>
        6.2
        您承诺并保证：您使用本服务及您的任何行为，不违反任何相关法规、本协议和相关协议、规则等。若魔果自行发现或根据相关部门的信息、权利人的投诉等发现您可能存在违反前述保证情形的，魔果有权根据《民法典》、《侵权责任法》、《著作权法》、《信息网络传播权保护条例》等法律法规，以一般人的认识做独立判断，以认定您是否存在违反前述保证情形，若魔果经过判断认为您存在违反前述保证情形的，魔果有权随时单方采取以下一项或多项措施。
      </p>
      <div class="list-wrap">
        <p>（1）要求您立即更换、修改违反前述保证情形的相关内容；</p>
        <p>
          （2）对存在违反前述保证情形的分享、您或您关联公司名下的全部分享服务或任何一款分享采取下线措施即终止分享服务在魔果云课的运营；
        </p>
        <p>（3）禁止您或您关联公司今后将任何新分享服务接入魔果云课；</p>
        <p>
          （4）中止、终止向违反前述保证情形的分享、您或您关联公司名下的全部分享或任何一款分享，或您或您关联公司提供部分或全部本服务，且追究您的法律责任；
        </p>
        <p>（5）其他魔果认为适合的处理措施，如将您的行为对外予以公告等。</p>
      </div>
      <p>
        6.2如您的分享或其它发布的作品被用户投诉，或因其它原因由魔果告知您或您自行得知您存在任何违法情形后，您应按法律法规或魔果的规定向魔果提出反通知、不侵权解释和担保。但是，无论魔果是否告知您、您是否提出反通知、解释或担保，或反通知是否符合相关法规、魔果要求等，均不影响魔果进行自己的独立判断和采取相关措施。
      </p>
      <p>
        6.3若魔果按照上述条款、本协议的其他相关约定或因您违反相关法律的规定，对您或您的分享采取任何行为或措施，所引起的纠纷、责任等一概由您自行负责，造成您损失的，您应自行全部承担，造成魔果及其关联公司或他人损失的，您也应自行承担全部责任。
      </p>
      <h2>关于免责</h2>
      <p>
        7.1
        您理解并同意：为了向您提供更完善的服务，魔果有权定期或不定期地对提供本服务的平台或相关设备进行检修、维护、升级等，此类情况可能会造成相关服务在合理时间内中断或暂停的，若由此给您造成损失的，您同意放弃追究魔果的责任。
      </p>
      <p>
        7.2您理解并同意：魔果的服务是按照现有技术和条件所能达到的现状提供的。魔果会尽最大努力向您提供服务，确保服务的连贯性和安全性；但魔果不能保证其所提供的服务毫无瑕疵，也无法随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力如然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。所以您也同意：即使魔果提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为魔果违约，同时，由此给您造成的数据或信息丢失等损失的，您同意放弃追究魔果的责任。
      </p>
      <p>
        7.3您理解并同意：若由于对以下情形导致的服务中断或受阻，给您造成损失的，您同意放弃追究魔果及其关联公司的责任：
      </p>
      <div class="list-wrap">
        <p>（1）您操作不当；</p>
        <p>（2）您通过非魔果授权的方式使用本服务；</p>
        <p>（3）其他魔果无法控制或合理预见的情形。</p>
      </div>
      <h2>关于通知</h2>
      <p>
        8.1
        魔果可能会以网页公告、网页提示、电子邮箱、手机短信、常规的信件传送、您注册的本服务账号的管理系统内发送站内信等方式中的一种或多种，向您送达关于本服务的各种规则、通知、提示等信息，该等信息一经魔果采取前述任何一种方式公布或发送，即视为您已经接受并同意，对您产生约束力。
        若您不接受的，请您书面通知魔果并停止使用本服务，否则视为您已经接受、同意。
      </p>
      <p>
        8.2
        若由于您提供的电子邮箱、手机号码、通讯地址等信息错误，导致您未收到相关规则、通知、提示等信息的，您同意仍然视为您已经收到相关信息并受其约束，一切后果及责任由您自行承担。
      </p>
      <p>
        8.3
        您也同意魔果及其关联公司或合作伙伴可以向您的电子邮件、手机号码等发送可能与本服务不相关的其他各类信息包括但不限于商业广告等。
      </p>
      <h2>知识产权</h2>
      <p>
        9.1
        魔果及其关联公司在本服务中提供的信息内容（包括但不限于网页、文字、图片、音频、视频、图表等）、相关的API服务的著作权、专利权均归魔果及其关联公司所有，依法属于用户、分享者及其他第三方所有的除外。
        除另有特别声明外，魔果提供本服务时所依托软件的著作权、专利权及其他知识产权均为合法所有。魔果在本服务中所使用的“魔果”、“魔果云课”等商业标识，其著作权或商标权归魔果及其合作权利人所有。上述及其他任何魔果及其合作权利人依法拥有的知识产权均受到法律保护。未经魔果及其合作权利人书面许可，您不得违约或违法使用，不得向任何单位或个人出售、转让、转授权上述的代码、API及开发工具或创造相关衍生作品等。
      </p>
      <p>
        9.2
        分享者同意并理解：分享者作为对其合法分享内容享有版权，分享者有权将在魔果云课上录制的分享视频使用在与任何与魔果云课平台相似的其他机构或平台，开展与本服务协议约定内容相同或类似的合作时需保证分享者所提供的分享服务结构和内容明显区分于本服务协议中提供的服务且不发生混淆。并承诺其服务售价不得低于在魔果云课平台的售价，否则魔果有权拒绝结算费用。
      </p>
      <h2>其他</h2>
      <p>10.1 用户购买课程服务后如需退款，按如下情况进行处理：</p>
      <p>
        10.1.1若用户购买课程订单完成之日起7日内可通过魔果云课平台在线提交退款申请，分享者在用户提交退款申请之日起7日内负责审核并处理。若分享者对用户退款申请审核通过的，则视为分享者已自动同意
        魔果云课平台通过系统自动向用户退款，同时用户将不再享有完成退款课程所有内容的学习权限；若分享者对用户退款申请审核不通过的，则不予退款，后续发生任何疑问需由分享者与用户自行商榷解决，平台不予干涉。若分享者在用户提交退款申请之日起7日内不予处理或怠于处理的，7日届满后，则视为分享者已自动同意魔果云课平台通过系统自动向用户退款，由此产生的不利后果由分享者自行承担，与魔果、魔果云课平台无关，用户和分享者对此均表示知晓并无异议。
      </p>
      <p>订单完成是指：用户付款成功且获得相关课程使用权。</p>
      <p>
        10.1.2用户和分享者均知晓并确认：通过魔果云课平台申请退款或魔果云课平台向用户退款的行为均基于分享者的授权、同意或其他经分享者确认的行为，魔果、魔果云课平台并不对用户与分享者是否退款及退款金额等行为进行任何干涉，也不向任何一方承担任何义务和责任。用户与分享者就退款相关的任何问题，均应自行协商或诉讼解决，与魔果、魔果云课平台无关。
      </p>
      <p>
        10.2本协议内容同时包括及魔果可能不断更新、发布的关于本服务的其他相关协议、规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，与本协议具有同等法律效力，您同样应当遵守。
      </p>
      <p>
        上述内容与本协议存在冲突的，以本协议为准。魔果有权在必要时单方修改本协议或上述内容，相关内容变更后，如果您继续使用本服务，即视为您已接受修改后的相关内容。如果您不接受修改后的相关内容，应当停止使用相关服务。
      </p>
      <p>10.3 本协议签订地为中华人民共和国北京市朝阳区。</p>
      <p>
        10.4
        本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。若您和魔果在履行本协议的过程中，如发生任何纠纷或争议，则双方应首先进行友好协商解决；协商不成的，任何一方有权向北京市朝阳区人民法院提起诉讼。
      </p>
      <p>
        10.5
        本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
      </p>
      <p>
        10.6
        本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
      </p>
      <p>（完）</p>
    </div>
  </div>
</template>
<script>
import { themeMixin } from '@saas/components/src/composables/useTheme';

const logoLight = require('../../assets/images/logo.png');
const logoDark = require('@saas/components/assets/images/logo-white.png');

export default {
  mixins: [themeMixin],
  data() {
    return {};
  },
  computed: {
    brandLogo() {
      return this.isDark ? logoDark : logoLight;
    },
  },
};
</script>
<style scoped src="../../assets/css/zx-agreement.css"></style>

<style scoped>
.header-img {
  filter: none;
}
</style>
